import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    'checkbox',
    'dropdown',
    'fieldsContainer',
    'programSection',
    'timezoneSection',
    'qualificationCheckbox',
    'qualificationDropdown'
  ];
  static values = { reportType: String };

  checkboxTargetConnected() {
    this.syncDropdownState();
  }

  qualificationCheckboxTargetConnected() {
    this.syncQualificationDropdownState();
  }

  qualificationDropdownTargetConnected() {
    this.syncQualificationDropdownState();
  }

  toggle() {
    this.syncDropdownState();
    if (this.checkboxTarget.checked) {
      this.clearSelections(this.dropdownTarget);
    }
  }

  toggleQualification() {
    this.syncQualificationDropdownState();
    if (this.qualificationCheckboxTarget.checked) {
      this.clearSelections(this.qualificationDropdownTarget);
    }
  }

  syncDropdownState() {
    if (!this.hasCheckboxTarget || !this.hasDropdownTarget) return;

    const container = this.dropdownTarget.querySelector('.js-admin-dropdown-container');
    if (this.checkboxTarget.checked || this.checkboxTarget.disabled) {
      if (container) container.classList.add('disabled');
    } else {
      if (container) container.classList.remove('disabled');
    }
  }

  syncQualificationDropdownState() {
    if (!this.hasQualificationCheckboxTarget || !this.hasQualificationDropdownTarget) return;

    const container = this.qualificationDropdownTarget.querySelector('.js-admin-dropdown-container');
    if (!container) return;

    if (this.qualificationCheckboxTarget.checked) {
      container.classList.add('disabled');
    } else {
      container.classList.remove('disabled');
    }
  }

  clearFields() {
    this.fieldsContainerTarget.innerHTML = '';
    this.reportTypeValue = '';
    const url = new URL(window.location);
    url.searchParams.delete('report_type');
    history.pushState({}, '', url);
  }

  reportTypeValueChanged() {
    this.updateProgramTimezoneState();
  }

  updateProgramTimezoneState() {
    const isNonProgramType = ['users', 'permissions', 'user_qualifications'].includes(this.reportTypeValue);

    if (this.hasProgramSectionTarget) {
      const checkbox = this.programSectionTarget.querySelector('input[type="checkbox"]');
      const dropdownContainer = this.programSectionTarget.querySelector('.js-admin-dropdown-container');

      if (checkbox) {
        checkbox.disabled = isNonProgramType;
        if (isNonProgramType) {
          checkbox.checked = false;
        }
      }

      if (dropdownContainer) {
        if (isNonProgramType) {
          dropdownContainer.classList.add('disabled');
        } else if (checkbox && !checkbox.checked) {
          dropdownContainer.classList.remove('disabled');
        }
      }
    }

    if (this.hasTimezoneSectionTarget) {
      const programRadio = this.timezoneSectionTarget.querySelector('input[value="program"]');
      const utcRadio = this.timezoneSectionTarget.querySelector('input[value="utc"]');

      if (isNonProgramType) {
        if (programRadio) {
          programRadio.disabled = true;
          programRadio.checked = false;
        }
        if (utcRadio) {
          utcRadio.checked = true;
        }
      } else {
        if (programRadio) {
          programRadio.disabled = false;
        }
      }
    }
  }

  clearSelections(dropdown) {
    const hiddenFields = dropdown.querySelectorAll(
      '[data-components--admin-dropdowns-dropdown-target="hiddenField"]'
    );
    hiddenFields.forEach((field, index) => {
      if (index === 0) {
        field.value = '';
      } else {
        field.remove();
      }
    });

    const menuItems = dropdown.querySelectorAll(
      '[data-components--admin-dropdowns-dropdown-target="menuItem"]'
    );
    menuItems.forEach(item => {
      item.classList.remove('js-selected', 'selected');
      const checkIcon = item.querySelector('.js-menu-option-check');
      if (checkIcon) {
        checkIcon.classList.add('invisible');
      }
    });

    const label = dropdown.querySelector(
      '[data-components--admin-dropdowns-dropdown-target="label"]'
    );
    const promptOption = dropdown.querySelector(
      '[data-components--admin-dropdowns-dropdown-target="promptOption"]'
    );
    if (label && promptOption) {
      label.innerHTML = promptOption.innerHTML;
    }
  }
}
